export default __webpack_public_path__ + "assets/icon-table-plus.ea644857.webp";